/* Polished — subtle scroll-reveal for sections.
   Adds .polished-revealed once a section enters the viewport.
   Respects prefers-reduced-motion via the matching CSS rule. */
(function () {
  if (typeof window === 'undefined') return;

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document
      .querySelectorAll('.shopify-section')
      .forEach(function (el) { el.classList.add('polished-revealed'); });
  }

  if (prefersReduced || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('polished-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  function init() {
    document.querySelectorAll('.shopify-section').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also handle sections rendered via theme editor (section reload events)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList) observer.observe(e.target);
  });
})();
